(ns guidebook.common
  (:require
   [util.core :refer [valid-date? to-utc-time]]
   [cljss.core :as cljss]
   [css.vars :as vars]
   ["moment" :as moment]
   [css.core
    :refer [get-theme]
    :refer-macros [defstyled]]))

;; We are using `to-utc-time` here because most of our data currently comes
;; straight from Salesforce into this page.
(defn format-date [ts]
  (if (valid-date? ts)
    (to-utc-time ts "MMMM Do, YYYY")
    "Unknown"))

(defstyled h1 :h1
  {:font-size "40px"
   :line-height "50px"
   :margin-bottom "30px"
   :text-align (with-meta #(or % "left") :text-align)
   :width (with-meta #(or % "auto") :width)
   :&:last-child {:margin-bottom "0"}})

(defstyled h2 :h2
  {:font-size "32px"
   :margin-bottom "20px"
   :&:last-child {:margin-bottom "0"}})

(defstyled text :div
  {:font-size "1.5625rem"
   :line-height "2.25rem"
   :font-weight "300"
   :width (with-meta #(or % "auto") :width)
   :color (with-meta #(or % vars/black) :color)
   :text-align (with-meta #(or % "left") :text-align)
   ::cljss/media {[:print]
                  {:font-size "20px"
                   :line-height "28px"}}})

(defstyled title-s :h1
  {:color (with-meta #(or % "black") :color)
   :font-size "94px"
   :font-weight 300
   :text-transform "uppercase"
   :margin (with-meta #(or % "0 0 2rem") :margin)
   :max-width (with-meta #(or % "970px") :max-width)
   :line-height "110px"
   :text-align (with-meta #(or % "left") :align)
   ::cljss/media {[:print]
                  {:font-size "68px"
                   :line-height "80px"
                   :-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin (with-meta #(or % "0 0 2rem") :margin)}}})

(defstyled body-s :p
  {:color (with-meta #(or % "black")
            :color)
   :font-size "1.5625rem"
   :font-weight (with-meta #(or % "300") :font-weight)
   :margin (with-meta #(or % "0") :margin)
   :line-height "2.25rem"
   :text-align (with-meta #(or % "left")
                 :align)
   ::cljss/media {[:print]
                  {:font-size "20px"
                   :line-height "32px"
                   :-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin (with-meta #(or % "0") :margin)}}})

(defstyled light-s :span
  {:font-weight "300"})

(defstyled score-gradient-s :div
  {:background "linear-gradient(to right, #21b3a3 0%,#f9bc50 51%,#d75e25 100%)"
   :filter "progid:DXImageTransform.Microsoft.gradient( startColorstr='#21b3a3', endColorstr='#d75e25',GradientType=1)"
   :height "1.5625rem"
   :border-radius "1.5625rem"
   :margin-bottom (with-meta #(or % "0") :margin-bottom)
   :box-shadow "inset 0 0 5px rgba(0,0,0,0.65)"
   :position "relative"
   :z-index "1"
   :&:before {:height "39px"
              :content ""
              :display "block"
              :width "3px"
              :position "absolute"
              :background vars/gray
              :top "-7px"
              :left "33.333%"}
   :&:after {:height "39px"
             :content ""
             :display "block"
             :width "3px"
             :position "absolute"
             :background vars/gray
             :top "-7px"
             :left "66.666%"}})

(defstyled score-wrapper-s :div
  {:position "relative"
   :z-index "1"})

(defstyled score-s :div
  {:display "grid"
   :grid-template-columns "repeat(30, 3.33%)"})

(defstyled return-s :div
  {:display "grid"
   :grid-template-columns "repeat(80, 1.25%)"
   :position "absolute"
   :top "-180px"
   :height "180px"
   :width "100%"})

(defstyled score-value-s :div
  {:color "white"
   :background (with-meta identity :color)
   :font-size (with-meta #(if % "32px" "42px") :overlap?)
   :border (str "1px solid " vars/black)
   :height "100%"
   :width "100%"
   :display "flex"
   :align-items "center"
   :justify-content "center"
   :border-radius "100%"})

(defstyled score-symbol-s :span
  {:color "white"
   :font-size (with-meta #(if % "18px" "26px") :overlap?)
   :margin-top (with-meta #(if % "10px" "12px") :overlap?)})

(defstyled score-label-s :div
  {:color vars/gray
   :font-weight "bold"
   :font-size "14px"
   :text-align "center"
   :width "90px"
   :grid-row (with-meta #(if % "3" "1") :bottom?)
   :margin (with-meta #(if % "10px auto 0" "0 auto 10px") :bottom?)})

(defstyled score-marker-circle-s :div
  {:border (str "1px solid " vars/black)
   :padding "5px"
   :background "white"
   :border-radius "100%"
   :width "110px"
   :height "110px"
   :margin (with-meta #(if % "5px 0 0" "0 0 5px") :bottom?)})

(defstyled score-marker-arrow-s :div
  {:border-top (with-meta #(if % "none" (str "16px solid " vars/gray)) :bottom?)
   :border-bottom (with-meta #(if % (str "16px solid " vars/gray) "none") :bottom?)
   :border-right "16px solid transparent"
   :border-left "16px solid transparent"
   :width "32px"
   :height "16px"
   :grid-column (with-meta #(or % "auto") :grid-column)
   :grid-row (with-meta #(if % "1" "3") :bottom?)
   :margin (with-meta #(if % "10px auto 0" "0 auto 10px") :bottom?)})

(defstyled score-location-s :div
  {:display "grid"
   :justify-content "center"
   :align-items "center"
   :grid-rows "max-content max-content max-content"
   :margin (with-meta #(or % "0") :margin)})

(defn show-score [{:keys [current target color bottom?]}]
  (if (> target 30)
    (when (= current 30)
      [score-location-s
       [score-label-s {:bottom? bottom?} "Risk Score"]
       [score-marker-circle-s {:bottom? bottom?}
        [score-value-s {:color color} target]]
       [score-marker-arrow-s {:bottom? bottom?}]])
    (when (= current target)
      [score-location-s
       [score-label-s {:bottom? bottom?} "Risk Score"]
       [score-marker-circle-s {:bottom? bottom?}
        [score-value-s {:color color} target]]
       [score-marker-arrow-s {:bottom? bottom?}]])))

(defn build-score [{:keys [current target bottom?]}]
  [score-wrapper-s
   (cond
     (< target 11) [show-score {:current current
                                :target target
                                :bottom? bottom?
                                :color "#21b3a3"}]
     (< target 21) [show-score {:current current
                                :target target
                                :bottom? bottom?
                                :color "#f9bc50"}]
     :else [show-score {:current current
                        :target target
                        :bottom? bottom?
                        :color "#d75e25"}])])

;; Table styling
(defstyled table-s :div
  {:margin-top (with-meta #(or % "6rem") :margin-top)})

(defstyled table-row-s :div
  {:display "grid"
   :grid-template-columns "1fr 1fr"
   :margin-top "1.5rem"
   :font-size "22px"
   :padding (with-meta #(if % "0 1.25rem 0 2rem" "0 1.25rem") :nested?)})

(defstyled inner-column-s :div
  {:color (with-meta #(or % "inherit") :color)
   :&:last-child {:text-align "right"}})

(defn make-row [{:keys [label value color nested?]}]
  [table-row-s {:nested? nested?}
   [inner-column-s label]
   [inner-column-s {:color color} value]])

(defstyled total-row-s :div
  {:display "flex"
   :justify-content "space-between"
   :align-items "center"
   :border-top (str "1px solid " vars/border-light)
   :padding "1.5rem 1.25rem 0"
   :margin-top "1.5rem"})

(defstyled header-row-s :div
  {:display "flex"
   :justify-content "space-between"
   :align-items "center"
   :border-bottom (str "1px solid " vars/border-light)
   :padding "0 1.25rem 1.25rem"
   :margin-bottom "1.25rem"})

(defstyled header-s :h3
  {:font-size "1.625rem"
   :font-weight "700"
   :color (with-meta #(or % "inherit") :color)
   :&:last-child {:text-align "right"}
   ::cljss/media {[:print]
                  {:-webkit-margin-before 0
                   :-webkit-margin-after 0}}})

(defstyled header-label-s :h4
  {:font-size "1rem"
   :border (str "1px solid " vars/border-light)
   :padding ".5rem"
   :color vars/gray
   :text-transform "uppercase"
   :font-weight "700"})

(defstyled sub-header-s :h4
  {:font-size "22px"
   :font-weight "700"
   :margin-top "2rem"
   :padding-left "1.25rem"
   ::cljss/media {[:print]
                  {:-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin-top "2rem"}}})

(defstyled net-worth-row-s :div
  {:display "flex"
   :align-items "center"
   :justify-content "space-between"
   :border-top "1px solid"
   :border-color (with-meta #(or % vars/border-light) :border-color)
   :margin (with-meta #(or % "1.5rem 0 0") :margin)
   :padding "1.25rem 1.25rem 0"})

(defstyled net-worth-header-s :h2
  {:font-size "2.5rem"
   :font-weight "700"
   :color (with-meta #(if % % "inherit") :color)})

(defstyled updated-s :div
  {:color "white"
   :background-color (get-theme :primary)
   :position "absolute"
   :right "0"
   :top "30vh"
   :font-size "22px"
   :font-weight "300"
   :line-height "25px"
   :height "70px"
   :display "flex"
   :align-items "center"
   :padding "0 45px"
   ::cljss/media {[:print]
                  {:top "82px"}}})
